import React from 'react';
import {TouchableOpacity} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import Spacer from '@/Atoms/Spacer';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import styles from '../ChatModal/styles';

type PsychologyModeToggleProps = {
  selected: boolean;
  onToggle: () => void;
};

function PsychologyModeToggle({selected, onToggle}: PsychologyModeToggleProps) {
  return (
    <TouchableOpacity onPress={onToggle} activeOpacity={0.7}>
      <Box
        style={[
          styles.PreQuestionsWrp,
          styles.normalShadow,
          {
            borderWidth: 1.5,
            borderColor: selected ? CCColors.Purple : 'transparent',
            backgroundColor: selected
              ? CCColors.MeetingStatus.Purple
              : CCColors.Primary.lightBrown,
          },
        ]}>
        <Box style={{padding: 20}} type="row-center-between">
          <Box type="row-flex-start">
            <Box
              style={{
                width: 35,
                height: 35,
                borderRadius: 35,
                backgroundColor: CCColors.Purple,
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <MaterialCommunityIcons name="brain" size={20} color={CCColors.White} />
            </Box>
            <Spacer spacing={10} horizontal />
            <CCText fontSize={FontSizes[14]}>Chess Psychology Expert</CCText>
          </Box>
          {selected ? (
            <MaterialIcons name="check-circle" size={22} color={CCColors.Purple} />
          ) : (
            <MaterialIcons
              name="radio-button-unchecked"
              size={22}
              color={CCColors.Grey.Grey}
            />
          )}
        </Box>
      </Box>
    </TouchableOpacity>
  );
}

export default PsychologyModeToggle;
